import { CSSProperties, createContext, useContext } from "react";

export const UniverseThemeContext = createContext<CSSProperties>({});

export const useUniverseTheme = () => useContext(UniverseThemeContext);
